// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".index {\n  position: relative;\n  width: 100vw;\n  min-height: 100vh;\n  padding-bottom: 30px;\n  background: #f5f7f9;\n  overflow: hidden;\n}\n.index .index-header-placeholder {\n  width: 100vw;\n  height: 58px;\n}\n.to-top-icon {\n  bottom: 40px;\n  right: 40px;\n}\n", ""]);
// Exports
module.exports = exports;
